import { Observable } from 'rxjs';
import {
  ApiService,
  CREATE_SINGLE_CHAT_PATH,
  CreateSingleChatBody,
  CreateSingleChatResponse,
  GET_CHANNEL_BY_REFERENCE_PATH,
  GET_CHANNEL_DETAILS_PATH,
  GET_SINGLE_CHANNEL_PATH,
  GetChannelByReferenceResponse,
  GetChannelDetailsPathParams,
  GetChannelDetailsResponse,
  GetSingleChannelPathParams,
  GetSingleChannelResponse,
  MUTE_CHANNEL_PATH,
  MuteChannelBody,
  MuteChannelPathParams
} from '@core-http';

export class ChatService extends ApiService {
  channelDetails(pathParams: GetChannelDetailsPathParams): Observable<GetChannelDetailsResponse> {
    const path: string = this.fillPathParams(GET_CHANNEL_DETAILS_PATH, pathParams);

    return this.httpClient.get<GetChannelDetailsResponse>(`${this.env.apiUrl}${path}`);
  }

  channelDetailsByReference(params: string): Observable<GetChannelByReferenceResponse> {
    return this.httpClient.get<GetChannelByReferenceResponse>(
      `${this.env.apiUrl}${GET_CHANNEL_BY_REFERENCE_PATH}?${params}`
    );
  }

  createSingleChat(payload: CreateSingleChatBody): Observable<CreateSingleChatResponse> {
    return this.httpClient.post<CreateSingleChatResponse>(`${this.env.apiUrl}${CREATE_SINGLE_CHAT_PATH}`, payload);
  }

  getSingleChannel(pathParams: GetSingleChannelPathParams): Observable<GetSingleChannelResponse | null> {
    const path: string = this.fillPathParams(GET_SINGLE_CHANNEL_PATH, pathParams);

    return this.httpClient.get<GetSingleChannelResponse | null>(`${this.env.apiUrl}${path}`);
  }

  muteChannel(pathParams: MuteChannelPathParams, payload: MuteChannelBody): Observable<void> {
    const path: string = this.fillPathParams(MUTE_CHANNEL_PATH, pathParams);

    return this.httpClient.patch<void>(`${this.env.apiUrl}${path}`, payload);
  }
}
